export const getSectionTitle = (intl) => {
  const sectionTitle = {
    profileSectionTitle: intl.formatMessage({ id: "RecordsPage.profile" }),
    companySectionTitle: intl.formatMessage({ id: "RecordsPage.companyDetails" }),
    locationSectionTitle: intl.formatMessage({ id: "RecordsPage.locationDetails" }),
    addressBookSectionTitle: intl.formatMessage({ id: "RecordsPage.addressBook" })
  }

  return { sectionTitle }
}